import { cx } from '@linaria/core';
import { useEffect } from 'react';
import { trackLoginInteraction } from '../../mfcLogic/lens';
import XLogo from '../Icons/XTwitter';
import Button from './Button';
import "./ButtonLoginX.linaria.module.css!=!./ButtonLoginX?./ButtonLoginX.linaria.module.css?css=H4sIAAAAAAAAA22Sy27jMAxF9/2KbgZoFyqs1G1sdTN/IsgyZbPRw5VZPyL03wdJxk6cmZVwJF4SV7wvipxsXyVMmorqZUPJqdigZxQ6wd+76ePnYSkw1KDdbem2vLhWl73kNI042FRj31k1C2NhfTZa8vY9fH4f7zB9fveEZmY6eAJPQoMniIsOdtKZZj+XqQVsWhJFeZ1p4dbQSqlTdY2+YVUgCm5japglD/1X2A1pxJpawbPs19rvIHE3Up5vae1nwZC4aaacbOw8GpdOVoUPHpanapL8MO69y+8wmeCJGeXQzgJ9CxFpEelCjrwZ5mpLF0mPRxD89Tpd97IyvglmS5fq8fJbb1m2lO+t5KEo2lwnHWyIYlDxibEWVA2REUz0vPqKcoiDhmlLZ5esxgiaMHgRw7jaBcm/Sq2b4x1eNGNUnfDhdKzp2uRhpaQsNp4hgev/jQKfbQdvfslCnl1/g8plFycrjKLyvQnRLVv57aBG9fjk0LPL5h/zgnfTczrL+aEauO5le6A54H+u/sYlz84zfx7+ACUmQk5SAwAA"
const embeddedStyles = "atm_h3_exct8b";
const baseStyles = "atm_h3_ftgil2";
const rootStyles = "atm_9s_1txwivl atm_fc_1h6ojuz atm_e2_mfg7y9 atm_le_exct8b atm_vy_1osqo2v";
const textStyles = "atm_lk_i2wt44 atm_am_glywfm atm_bx_1kw7nm4 atm_c8_w1gvyb atm_cs_bfngof";
const buttonOverrides = "atm_7l_1o88h4c atm_9s_1txwivl atm_ar_vrvcex atm_be_1q9ccgz atm_h_1h6ojuz atm_fc_1h6ojuz atm_e2_1ylpe5n atm_vy_1osqo2v atm_t9_glywfm atm_c8_w1gvyb atm_1kbv1cs_hktyoi";
const ButtonLoginX = ({
  embedded,
  signup
}) => {
  useEffect(() => {
    const twitterButtonScript = event => {
      // eslint-disable-next-line @typescript-eslint/no-deprecated
      const domain = '.' + document.domain.replace(/.*?(\w+\.\w+)$/, '$1');
      // is this message for us?
      if (event?.origin?.indexOf(domain) && event?.origin?.indexOf(domain) + domain.length === event?.origin?.length && event?.data && typeof event.data === 'string' && event?.data?.indexOf('http') === 0) {
        const url = event.data + location.search.replace(/^\?/, '&').replace(/&request=\w+/, '') + '&load=app&mode=app&client_id=1101';

        // indicate that the client is to be returned to app.mfc
        location.href = url;
      }
      // else {
      //     console.log(
      //         'message received from another origin',
      //         domain,
      //         event.origin,
      //     )
      // }
    };
    window.addEventListener('message', twitterButtonScript);
    return () => {
      window.removeEventListener('message', twitterButtonScript);
    };
  }, []);
  return <section className={rootStyles}>
            <Button onClick={() => {
      trackLoginInteraction(signup, 'x');
      window.Twitter_SignIn();
    }} id="twitter-button" size="large" clean border className={cx('twitter_button', buttonOverrides, embedded ? baseStyles : embeddedStyles)}>
                <XLogo />
                <div className={textStyles}>
                    {signup ? 'Sign up' : 'Sign in'} with X
                </div>
            </Button>
        </section>;
};
export default ButtonLoginX;